import React, { useState, useEffect } from "react" ;

import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildResources } from "root/DataFunctions/ChildDataFns";

import ResourceCard from "../Components/UI/ResourceCard";
import Loading from "../Components/Loading";

const ArchBoxHelp = () => {
    const [allHelp, setAllHelp] = useState("");
    
    useEffect(() => {
        getChildResources(3, (response) =>
        {
            setAllHelp(getDataFromResponse(response));
        });
    }, []);

    return (
        <div style={{flex: "1"}}>
            <div className="child_breadcrumb child_breadcrumb-main">
                <div className="child_breadcrumb_inner">
                    <h2 className="child_breadcrumb_title">
                        Help
                    </h2>
                </div>
            </div>
            <div className="article-container">
                {allHelp 
                    ? allHelp.map((help) =>
                        <ResourceCard 
                            key={help.resource_id} 
                            icon_id={help.icon_id}
                            link={help.link}
                            document_id={help.document_id}
                            name={help.name}
                            description={help.description}
                        />
                    ) 
                    : <Loading />
                }
            </div>
        </div>
    );
}

export default ArchBoxHelp;
